export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
} as const;